import { SectionTitle } from '@components/common/section-title';
import { TextDescriptionFade } from '@components/common/description/TextDescriptionFade';
import { TestId } from '@components/test-ids';
import styled from '@emotion/styled';
import { Theme, ThemeProps } from '@theme/base';
import { withTheme } from '@emotion/react';
import dynamic from 'next/dynamic';
import React from 'react';
import { SkeletonElement, SkeletonVariant } from '@components/common/skeleton-loading';

/* ***************** *
 *       Types       *
 * ***************** */
export interface LocalAreaInfoProps {
  theme?: Theme;
  testId?: string;
  description?: string;
  mapMarkerLabel: string;
  latitude: string;
  longitude: string;
  isGhosting?: boolean;
}

const Map = dynamic(() => import('../../common/map/Map'), {
  ssr: false
});

/* ***************** *
 *       Styles      *
 * ***************** */
const Container = styled.div({});

const ComponentContainer = styled.div({});

const TextDescription = styled(TextDescriptionFade)(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.large
}));

/* **************************** *
 *    LocalAreaInfoComponent    *
 * **************************** */

export const LocalAreaInfoComponent = ({
  testId,
  mapMarkerLabel,
  latitude,
  longitude,
  description = '',
  isGhosting
}: LocalAreaInfoProps) => {
  if (isGhosting) {
    return (
      <Container data-testid={testId || TestId.localAreaInfo.main}>
        <SectionTitle heading={'product__local-area-info--title'} />
        <SkeletonElement repeat={3} />
        <SkeletonElement variant={SkeletonVariant.RECTANGLE} width={'100%'} height={300} />
      </Container>
    );
  }

  return (
    <Container data-testid={testId || TestId.localAreaInfo.main}>
      <SectionTitle heading={'product__local-area-info--title'} />
      <ComponentContainer>
        {description && <TextDescription description={description} />}
        {!!latitude && !!longitude && (
          <Map mapMarkerLabel={mapMarkerLabel} latitude={Number(latitude)} longitude={Number(longitude)} />
        )}
      </ComponentContainer>
    </Container>
  );
};

export const LocalAreaInfo = withTheme(LocalAreaInfoComponent);
